import React from 'react';
import { Container, Box, Typography, TextField, Button, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import DrawIcon from '@mui/icons-material/Draw';

const SignIn = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your sign-in logic here
    console.log('Sign in submitted');
  };

  return (
    <div className="min-h-screen">
      <Header />
      <Container
        maxWidth="sm"
        sx={{ py: 8 }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: 3,
            p: 4
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
            <DrawIcon sx={{ fontSize: 40, color: theme.palette.brand.brand }} />
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, color: theme.palette.brand.brand }}
            >
              Fence Sketch
            </Typography>
          </Box>

          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            Welcome Back
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.interactions.subtle.default, mb: 4 }}
          >
            Sign in to your account
          </Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ width: '100%' }}
          >
            <TextField
              fullWidth
              label="Email"
              type="email"
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              required
            />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mb: 3 }}>
              <Link
                href="#"
                sx={{
                  color: theme.palette.brand.brand,
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Forgot password?
              </Link>
            </Box>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{ py: 1.5, fontSize: '1.1rem', fontWeight: 600, mb: 3 }}
            >
              Sign In
            </Button>

            <Typography
              variant="body2"
              align="center"
              sx={{ color: theme.palette.interactions.subtle.default }}
            >
              Don't have an account?{' '}
              <Link
                onClick={() => navigate('/signup')}
                sx={{
                  color: theme.palette.brand.brand,
                  textDecoration: 'none',
                  fontWeight: 600,
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Sign Up
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default SignIn;
